import { MeshPhysicalMaterial, BackSide, Material } from "three";

export const SphereFresnelMaterial = async (args: any) => {
	const material = new MeshPhysicalMaterial({
		metalness: 0,
		roughness: 0.1,
		clearcoat: 1,
		clearcoatRoughness: 0,
		transparent: true,
		transmission: 1,
		opacity: 1,
		reflectivity: 1.5,
		envMapIntensity: 1.5,
		thickness: 1,
		depthWrite: true,
		depthTest: false,
		ior: 1.5,
		iridescenceIOR: 0,
		iridescenceThicknessRange: [0, 1200],
		side: BackSide,
	});

	return material as Material;
};
